import React, { FC, useCallback } from "react";

import CustomerList from "../components/Customer/CustomerList";
/* import Filter from "../components/Filter/Filter"; */
import NavbarReports from "../components/Navigation/Navbar/Reports";
import NavbarSettings from "../components/Navigation/Navbar/Settings";

import { default as CustomerSettingsOverlay } from '../components/Customer/CustomerSettings/SettingsOvererlay/SettingsOverlay';
import Layout from '../components/Layout/Customer';
import { useNamedRoutes } from '../components/NamedRoutes';
import NavbarMain from '../components/Navigation/Navbar/Main';
import SidebarCustomer from "../components/Navigation/Sidebar/Customer";
import SidebarMain from '../components/Navigation/Sidebar/Main';
import { default as UserSettingsOverlay } from '../components/User/UserSettings/SettingsOvererlay/SettingsOverlay';

import
{
  useCustomer,
  useMyCustomers
} from "../components/ReactData/customer";

import { Customer as CustomerT, User, UserPermissions, permissionAllowed } from "@ews/react-data";
import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import NewCustomerModal from "../components/Customer/NewCustomer/NewCustomerModal";
import { FilterState } from "../components/FilterList/types";
import { useMyPermissions } from "../components/Login/LoginProvider";
import { MenuLink } from "../components/Navigation/Sidebar/Sidebar";
import StatusbarMain from '../components/Navigation/Status/Main';
import { MenuToggleProps } from "../components/Navigation/types";
import { usePersistentState } from "../components/Persistence";
import { ReactClickEvent } from "../components/types";
import UserList from '../components/User/UserList';
import { setTitle } from "../utils";

const CustomerSettings: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  const { translate: t } = useL10n();

  const customer = useCustomer(id!);
  //const customer = customerList.filter(c => c.id === id)[0];

  setTitle(`${t('COM_FACPMANAGEMENT_BALANCE_CUSTOMER_LABEL')}`, `${customer.name}`, `[${customer.customerNumber}]`);

  return <>
    <Layout customer={customer} backbutton={true} title={customer.name} navbar={NavbarSettings} sidebar={SidebarCustomer} id="customer:settings">
      <CustomerSettingsOverlay customer={customer} />
    </Layout >
  </>;

};

const CustomerShowAllSystems: React.FC = () =>
{
  //const systems = useMySystems();
  const { params } = useNamedRoutes();
  const { id } = params();
  const customer = useCustomer(id!);

  return (
    <>
      <Layout customer={customer} backbutton={true} title={customer.name} navbar={NavbarReports} sidebar={SidebarCustomer} id="customer:systems">
        {/* <SystemList systems={customerSystemList} /> */}
      </Layout >
    </>

  );
};


const CustomerShowAllUsers: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  const { translate: t } = useL10n();

  const customer = useMyCustomers().filter(c => c.id === id)[0];
  //const userList: any[] = [];//users.filter(user => user.customerId === id);
  setTitle(`${t('COM_ADMIN_HELP_USERS_USER_MANAGER')}`, `${customer.name}`, `[${customer.customerNumber}]`);

  return (
    <>
      <Layout customer={customer} backbutton={true} navbar={NavbarReports} sidebar={SidebarCustomer} id="customer:users">
        <UserList />
      </Layout >
    </>

  );
};

const CustomerAddCustomer: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  const customer = useCustomer(id!);

  const newCustomer = {
    name: '',
    id: '',
    address: '',
    plz: 0,
    city: '',
    land: '',
    email: '',
    tel: ''
  };

  return <>
    <>
      <Layout customer={customer} backbutton={true} navbar={NavbarReports} sidebar={SidebarCustomer} id="customer:addcustomer">
        <CustomerSettingsOverlay customer={newCustomer as unknown as CustomerT} />
      </Layout>
    </>
  </>;
};

const CustomerAddUser: React.FC = () =>
{
  const { params } = useNamedRoutes();

  const { id } = params();
  const customer = useCustomer(id!);

  const newUser = {
    username: '',
    //customerId: id || "",
    password: '',
    active: false,
    email: ''
  };

  return <>
    <Layout customer={customer} backbutton={true} navbar={NavbarReports} sidebar={SidebarCustomer} id="customer:adduser">
      <UserSettingsOverlay user={newUser as unknown as User} />
    </Layout>
  </>;
};

const SidebarWrapper: FC<MenuToggleProps> = ({ onMenuToggle }) =>
{
  const { translate: t } = useL10n();
  const permissions: UserPermissions = useMyPermissions();

  return (<SidebarMain onMenuToggle={onMenuToggle}>
    {permissionAllowed(permissions.createCustomer!) ? <>
      <MenuLink
        title={t('[REACT_ADD_CUSTOMER]')}
        id="newCustomer"
        icon={<Icon icon="clients_create" />}
      />
      <NewCustomerModal onDismiss={(e) => onMenuToggle && onMenuToggle(e as unknown as ReactClickEvent)} trigger={"newCustomer"} />
    </> : <></>}
  </SidebarMain>);
};


const Customer: React.FC<{ filterByCustomer?: boolean; }> = ({ filterByCustomer }) =>
{

  const { params } = useNamedRoutes();
  const { id: parentId } = params();
  const { translate: t } = useL10n();


  const [FilterState, setFilterState] = usePersistentState<FilterState>('customer-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);
  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState.isFilterActive, setFilterState]);

  setTitle(`${t('COM_FACPMANAGEMENT_FACP_MANAGER_CUSTOMERS')}`);

  const Bar = () =>
  {
    return <>

      <StatusbarMain
        filter
        isFilterOpen={FilterState.isFilterOpen}
        activeFilter={FilterState.isFilterActive}
        onFilterOpen={onFilterOpen}
      />
    </>;
  };

  if (filterByCustomer && !parentId) return <></>;

  return (
    <>
      <Layout header={false} statusbar={Bar} navbar={NavbarMain} sidebar={SidebarWrapper} id="customer">
        <CustomerList
          parentId={filterByCustomer ? parentId : undefined}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
        {/* <CustomerAddBtn
          id={"NewCustomer"}
          icon={add}
          color={"success"}
          onClick={() =>
          {
            setOpenAddSystemSettings(!openAddSystemSettings);
          }} />
        <NewCustomerModal trigger="NewCustomer" /> */}
      </Layout>

    </>

  );
};
export
{
  Customer, CustomerAddCustomer,
  CustomerAddUser, CustomerSettings,
  CustomerShowAllSystems,
  CustomerShowAllUsers
};
